// Fuso horário da loja para EXIBIÇÃO de datas/horas.
// Os timestamps chegam do backend em UTC (muitas vezes SEM sufixo "Z"), então
// aqui fazemos DUAS coisas globalmente:
//   1) Patch no construtor Date: strings de data-HORA "ingênuas" (sem timezone)
//      são tratadas como UTC (adiciona "Z"), evitando que o navegador as
//      interprete como horário local.
//   2) Patch nos métodos toLocaleString/toLocaleDateString/toLocaleTimeString:
//      força o fuso da loja por padrão na formatação.
//
// Padrão: America/Sao_Paulo (Horário de Brasília, UTC-3).
// O fuso pode ser atualizado em runtime com setStoreTimezone(name) após buscar
// as configurações da empresa (campo settings.timezone).

const DEFAULT_TZ = 'America/Sao_Paulo';
let currentTZ = DEFAULT_TZ;

export const getStoreTimezone = () => currentTZ;

export const setStoreTimezone = (name) => {
  if (!name || typeof name !== 'string') return;
  try {
    // valida o nome do fuso
    new Intl.DateTimeFormat('pt-BR', { timeZone: name });
    currentTZ = name;
  } catch (e) {
    // fuso inválido → mantém o atual
  }
};

// 1) Trata strings de data-hora SEM timezone como UTC.
// Ex.: "2026-09-01T17:07:40.134000" ou "2026-09-01 17:07:40" -> "...Z".
// Strings apenas com data ("2026-09-01") ou já com timezone ("...Z"/"+00:00")
// NÃO são alteradas.
(function patchDateConstructorUTC() {
  const _Date = Date;
  if (_Date.__utcPatched) return;
  const naiveDateTime = /^\d{4}-\d{2}-\d{2}[T ]\d{2}:\d{2}(:\d{2})?(\.\d+)?$/;

  const normalize = (s) => {
    const t = s.trim();
    if (naiveDateTime.test(t)) {
      return t.replace(' ', 'T') + 'Z';
    }
    return s;
  };

  function PatchedDate(...args) {
    // Chamado sem "new" (ex.: Date()) -> comportamento original (string atual)
    if (!(this instanceof PatchedDate)) {
      return _Date();
    }
    if (args.length === 1 && typeof args[0] === 'string') {
      args = [normalize(args[0])];
    }
    return new _Date(...args);
  }

  // Preserva protótipo e membros estáticos
  PatchedDate.prototype = _Date.prototype;
  PatchedDate.now = _Date.now;
  PatchedDate.parse = (s) => (typeof s === 'string' ? _Date.parse(normalize(s)) : _Date.parse(s));
  PatchedDate.UTC = _Date.UTC;
  PatchedDate.__utcPatched = true;

  // eslint-disable-next-line no-global-assign
  Date = PatchedDate;
})();

// 2) Aplica o fuso da loja como padrão nos métodos de formatação do Date.
(function patchLocaleTimezone() {
  const methods = ['toLocaleString', 'toLocaleDateString', 'toLocaleTimeString'];
  methods.forEach((method) => {
    const original = Date.prototype[method];
    if (original.__tzPatched) return;
    const patched = function (locales, options) {
      const opts = options ? { ...options } : {};
      if (!opts.timeZone) opts.timeZone = currentTZ;
      return original.call(this, locales || 'pt-BR', opts);
    };
    patched.__tzPatched = true;
    // eslint-disable-next-line no-extend-native
    Date.prototype[method] = patched;
  });
})();
